module.exports = __webpack_public_path__ + "img/43e8c8d16467e7421d6eb7356e961cc0.png";